import styled from 'styled-components';
import { ResponsiveContainer as UnstyledResponsiveContainer } from 'recharts';

import { Text as UnstyledText } from 'features/common/components/Text';

export const Text = styled(UnstyledText)`
	display: flex;
	gap: 10px;
	font-weight: 500;
	font-size: 25px;
	line-height: 38px;
`;

export const Amount = styled(Text)`
	color: ${({ theme }) => theme.colors.green};
`;

export const Container = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 24px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		flex-direction: column;
	}
`;

export const ResponsiveContainer = styled(UnstyledResponsiveContainer)`
	font-family: ${({ theme }) => theme.fonts.primary};
`;

export const ContainerTooltip = styled.div`
	background: ${({ theme }) => theme.colors.grey};
	border-radius: 4px;
	padding: 5px 8px 5px 8px;
	border: ${({ theme }) => `0.5px solid ${theme.colors.lightGrey2}`};
	text-align: center;
`;

export const TextTooltip = styled(UnstyledText)`
	font-weight: 500;
	font-size: 15px;
	line-height: 20px;
	display: flex;
	justify-content: center;
`;

export const BottomInfo = styled(Text)`
	font-size: 16px;
	margin-bottom: 24px;
	line-height: 24px;
	margin-top: 16px;
	margin-left: 24px;
`;
